<div style="width: 608px; height: 699px;" class="relative"
  *ngIf="{loading: loading$ | async, appointmentCases: appointmentCases$ | async } as data">
  <svg width="28" height="28" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="cancel()"
    class="top-0 right-0 absolute cursor-pointer" preserveAspectRatio="none">
    <path
      d="M12 14.2133L7.09999 19.4108C6.91665 19.6052 6.68332 19.7025 6.39999 19.7025C6.11665 19.7025 5.88332 19.6052 5.69999 19.4108C5.51665 19.2163 5.42499 18.9688 5.42499 18.6683C5.42499 18.3677 5.51665 18.1202 5.69999 17.9258L10.6 12.7284L5.69999 7.53094C5.51665 7.33648 5.42499 7.08898 5.42499 6.78845C5.42499 6.48792 5.51665 6.24043 5.69999 6.04596C5.88332 5.8515 6.11665 5.75427 6.39999 5.75427C6.68332 5.75427 6.91665 5.8515 7.09999 6.04596L12 11.2434L16.9 6.04596C17.0833 5.8515 17.3167 5.75427 17.6 5.75427C17.8833 5.75427 18.1167 5.8515 18.3 6.04596C18.4833 6.24043 18.575 6.48792 18.575 6.78845C18.575 7.08898 18.4833 7.33648 18.3 7.53094L13.4 12.7284L18.3 17.9258C18.4833 18.1202 18.575 18.3677 18.575 18.6683C18.575 18.9688 18.4833 19.2163 18.3 19.4108C18.1167 19.6052 17.8833 19.7025 17.6 19.7025C17.3167 19.7025 17.0833 19.6052 16.9 19.4108L12 14.2133Z"
      fill="#515251"></path>
  </svg>
  <p style="font-family: 'Open Sans'; font-size: 22px; font-weight: 600; color: #515251; padding: 24px 0px 0px 15px">
    Line items
  </p>
  <div *ngIf="!data.loading; else loading">
    <div *ngIf="data?.appointmentCases?.error; else noError" style="padding: 38px 0px 0px 15px;" class="flex flex-col">
      <span
        style="font-family: 'Open Sans'; font-style:normal;font-weight:400;font-size:22px; line-height: 110%; color: #eb0e33;">{{data.appointmentCases.error}}</span>
    </div>
    <ng-template #noError>
      <div style="padding: 38px 0px 0px 15px; height: 575px; overflow-y:scroll ;" class="flex flex-col"
        *ngIf="data.appointmentCases.length > 0; else noAppointmentCases">
        <div *ngFor="let appointmentCase of data.appointmentCases; let i = index"
          style="width: 575px; left: 254px; font-size: 16px; text-align: left; color: #515251;" class="py-3">
          <span
            style="font-family: 'Open Sans'; font-style:normal;font-weight:400;font-size:16px; line-height: 110%;width: 469px; height: 49px; font-size: 16px; text-align: left; color: #515251;"><b>{{appointmentCase.sequence}}.</b>
            {{appointmentCase.opCode ? appointmentCase.opCode + ' -': ''}} {{appointmentCase.requestDescription}}
          </span>
          <svg width="570" height="1" viewBox="0 0 570 1" fill="none" xmlns="http://www.w3.org/2000/svg"
            style="padding-left:20px; margin-top: 10px;" preserveAspectRatio="none">
            <line y1="0.75" x2="570" y2="0.75" stroke="black" stroke-opacity="0.26" stroke-width="0.5"></line>
          </svg>
        </div>
      </div>
    </ng-template>
    <ng-template #noAppointmentCases>
      <div class="flex flex-col" style="padding: 38px 0px 0px 15px;">
        <span
          style="font-family: 'Open Sans'; font-style:normal;font-weight:400;font-size:22px; line-height: 110%; color: #515251;">
          No line items exist for this appointment.
        </span>
      </div>
    </ng-template>
  </div>
  <ng-template #loading>
    <div style="width: 580px; height: 525px; margin: 38px 0px 0px 15px;" class="animated-background rounded-md">
    </div>
  </ng-template>
  <div class='flex justify-center items-center absolute pt-3 cursor-pointer bottom-0 right-0'
    style="width: 106px; gap: 8px; border-radius: 4px; background: #0054a6;">
    <p [mat-dialog-close]="true" style="flex-grow: 0; flex-shrink: 0; font-size: 16px; text-align: left; color: #fff;">
      Check-in
    </p>
  </div>
</div>